import React from 'react';
import PropTypes from 'prop-types';

import {
    RIQPopover
} from '../RIQPopover.jsx';

MetricTableHeader.Alignment = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    CENTER: 'CENTER'
};

MetricTableHeader.SortIndicator = {
    SORT_DOWN: 'SORT_DOWN',
    SORT_UP: 'SORT_UP'
};

MetricTableHeader.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.string,
    alignment: PropTypes.oneOf(_.keys(MetricTableHeader.Alignment)),
    sortIndicator: PropTypes.oneOf(_.keys(MetricTableHeader.SortIndicator)),
    onClick: PropTypes.func
};

export default function MetricTableHeader({alignment = MetricTableHeader.Alignment.LEFT, className, description, onClick, sortIndicator, title, titleFormatter = _.startCase}) {

    const headerInnerContentEl = (
        <div
            className='tlw-flex tlw-min-h-[33px] tlw-items-center tlw-text-11 tlw-font-normal tlw-text-gray-800'>
            {_.isString(title) && titleFormatter ? titleFormatter(title) : title}

            {sortIndicator &&
                <span
                    className={`fa tlw-ml-6 ${sortIndicator === MetricTableHeader.SortIndicator.SORT_UP ? 'fa-caret-up' : 'fa-caret-down'}`}
                />
            }
        </div>
    );

    const showPointerCursor = Boolean(onClick);

    let headerWithPopover;
    let alignmentClass;
    if (alignment === MetricTableHeader.Alignment.LEFT) {
        alignmentClass = 'tlw-items-start tlw-text-left';
    } else if (alignment === MetricTableHeader.Alignment.CENTER) {
        alignmentClass = 'tlw-items-center tlw-text-center';
    } else {
        alignmentClass = 'tlw-items-end tlw-text-right';
    }

    if (description) {
        headerWithPopover = (
            <RIQPopover
                triggerNode={headerInnerContentEl}
                className={`tlw-flex tlw-w-full ${showPointerCursor ? 'tlw-cursor-pointer' : 'tlw-cursor-default'} tlw-flex-col ${alignmentClass}`}
                placement='top'
                additionalHookProps={{
                    delayShow: RIQPopover.StandardDelayMS
                }}
            >
                <div
                    className='tlw-px-7 tlw-py-4.5 tlw-font-normal tlw-leading-base tlw-text-gray-900' >
                    {description}
                </div>
            </RIQPopover>
        );
    } else {
        headerWithPopover = (
            <div
                className={`tlw-flex tlw-flex-col ${alignment === MetricTableHeader.Alignment.LEFT ? 'tlw-items-start' : 'tlw-items-end'}`}>
                {headerInnerContentEl}
            </div>
        );
    }

    return (
        <th
            className={`tlw-border tlw-border-l-0 tlw-border-t-0 tlw-border-solid tlw-border-[rgba(0,0,0,.05)] tlw-p-4 last_tlw-border-r-0 ${showPointerCursor ? 'tlw-cursor-pointer' : ''} ${className || ''}`}
            onClick={onClick}>
            {headerWithPopover}
        </th>
    );
}
